import { render } from "./products-movement.vue?vue&type=template&id=2609f1b2"
import script from "./products-movement.vue?vue&type=script&lang=js"
export * from "./products-movement.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__